export default __webpack_public_path__ + "static/media/Strangler's Boots of the Silent Kill.3004c5b2.jpg";